export default __webpack_public_path__ + "static/media/diplodocus.d81accf4.png";